import React, { useEffect, useState } from 'react'
import { deleteDesignation, getDesignations, getPipelines, upserDesignation, upsertSubDesignation, deleteSubDesignation } from '../../utils/urls'
import axios from '../../utils/axios';
import { InputText } from 'primereact/inputtext';
import FlexComponent from '../FlexComponent';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useSelector } from 'react-redux';
import { MultiSelect } from 'primereact/multiselect';
import { confirmDialog } from '../../shared/ConfirmModal';
import { Divider } from 'primereact/divider';

function Designations({ toast }) {
    const [title, setTitle] = useState('')
    const [editTitle, setEditTitle] = useState('')
    const [editPipelines, setEditPipelines] = useState([])
    const [pipelinesList, setPipelinesList] = useState([])
    const [selectedPipelines, setSelectedPipelines] = useState([])
    const userId = useSelector(state => state.user.userId);

    const [isAddDesignation, setIsAddDesignation] = useState(false)
    const [designationList, setDesignationList] = useState([])
    const [designationEditIndex, setDesignationEditIndex] = useState()
    const [isDesignationEdit, setIsDesignationEdit] = useState()

    const [loading, setLoading] = useState(true)
    const [isMounted, setIsMounted] = useState(false)

    // States for sub-designation
    const [showAddSubDesignationInput, setShowAddSubDesignationInput] = useState(null);
    const [subDesignationTitle, setSubDesignationTitle] = useState('');
    const [editSubDesignationId, setEditSubDesignationId] = useState(null);
    const [editSubDesignationTitle, setEditSubDesignationTitle] = useState('');

    const handleAddDesignation = () => {
        setIsMounted(true)
        setIsAddDesignation(false)
        const data = {
            title: title,
            pipelines: selectedPipelines
        }
        axios.post(upserDesignation, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setTitle('')
                    setSelectedPipelines([])
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Designation added successfully', life: 3000 });
                    setIsMounted(false)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
    }

    const handleEditSubmit = (id) => {
        setIsDesignationEdit(false)
        setIsMounted(true)
        const data = {
            designation_id: id,
            title: editTitle,
            pipelines: selectedPipelines
        }
        const url = `${upserDesignation}`
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Designation updated successfully', life: 3000 });
                    setIsMounted(false)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
    }

    const handleClick = () => {
        setSelectedPipelines([])
        setTitle('')
        setIsAddDesignation(!isAddDesignation)
        setIsDesignationEdit(false);
        setShowAddSubDesignationInput(null);
        setEditSubDesignationId(null);
    }

    const handleEdit = (index) => {
        setIsAddDesignation(false)
        setIsDesignationEdit(true);
        setDesignationEditIndex(index);
        setEditTitle(designationList[index].title);
        setSelectedPipelines(designationList[index].pipelines.map(list => list.id))
        setShowAddSubDesignationInput(null);
        setEditSubDesignationId(null);
    };

    const getAllDesignations = () => {
        const url = `${getDesignations}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    setDesignationList(response.data)
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    const getPipelinesList = () => {
        if (userId) {
            const pipelineUrl = `${getPipelines}?userId=${userId}`;
            axios.get(pipelineUrl, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then((response) => {
                    if (response.status === 200) {
                        const options = response?.data?.map((user) => ({
                            label: user.name,
                            value: user.id
                        })) || [];
                        setPipelinesList(options);
                    }
                })
                .catch(() => { });
        }
    };

    const handleDelete = (list) => {
        setIsMounted(true)
        confirmDialog({
            message: 'Are you sure you want to delete this Designation?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const Url = `${deleteDesignation}${list.id}`
                axios.post(Url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Designation deleted successfully', life: 3000 });
                            setIsMounted(false)
                        }
                        else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false)
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false)
                    })
            },
            reject: () => {
                console.log("Deletion cancelled")
            }
        });
    };

    const handleAddSubDesignation = (designationId) => {
        setIsMounted(true);
        const data = {
            designation_id: designationId,
            title: subDesignationTitle
        };
        axios.post(upsertSubDesignation, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setSubDesignationTitle('');
                    setShowAddSubDesignationInput(null);
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Sub-designation added successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to add sub-designation', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong adding sub-designation', life: 3000 });
            });
    };

    const handleEditSubDesignation = (designationId, subDesignationId, currentTitle) => {
        setEditSubDesignationId(subDesignationId);
        setEditSubDesignationTitle(currentTitle);
        setShowAddSubDesignationInput(null);
    };

    const handleUpdateSubDesignation = (designationId, subDesignationId) => {
        setIsMounted(true);
        const data = {
            designation_id: designationId,
            subdesignation_id: subDesignationId,
            title: editSubDesignationTitle
        };
        axios.post(upsertSubDesignation, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setEditSubDesignationId(null);
                    setEditSubDesignationTitle('');
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Sub-designation updated successfully', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to update sub-designation', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong updating sub-designation', life: 3000 });
            });
    };

    const handleDeleteSubDesignation = (designationId, subDesignationId) => {
        setIsMounted(true);
        confirmDialog({
            message: 'Are you sure you want to delete this Sub-designation?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const url = `${deleteSubDesignation}${subDesignationId}`;
                axios.post(url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'Sub-designation deleted successfully', life: 3000 });
                            setIsMounted(false);
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false);
                        }
                    })
                    .catch((error) => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false);
                    });
            },
            reject: () => {
                console.log("Sub-designation deletion cancelled");
            }
        });
    };

    const userTemplate = (option) => {
        return (
            <FlexComponent justifyContent="start">
                <span>{option.label}</span>
            </FlexComponent>
        );
    };

    useEffect(() => {
        getAllDesignations()
        getPipelinesList()
    }, [isMounted])

    return (
        <div>
            {designationList?.length > 0 &&
                <div>
                    {designationList.map((list, index) => (
                        <div key={index} style={{ marginTop: ".5rem" }} >
                            {!isDesignationEdit || designationEditIndex !== index ? (
                                <FlexComponent gap="1rem" >
                                    <FlexComponent justifyContent="start" style={{ height: "50px", width: "100%" }} >
                                        <p style={{ fontWeight: "bold", fontSize: "1.2rem" }} >{list.title}</p>
                                    </FlexComponent>
                                    <Button style={{ padding: ".5rem .6rem" }} onClick={() => {
                                        handleEdit(index)
                                    }} icon="pi pi-pencil" />
                                    <Button style={{ padding: ".5rem .6rem" }} onClick={() => {
                                        handleDelete(list)
                                    }} icon="pi pi-trash" />
                                </FlexComponent>
                            ) : (
                                <FlexComponent style={{ marginTop: "1rem", border: "1px solid grey", padding: "1rem", borderRadius: "15px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                                        <label htmlFor="email" style={{ fontWeight: 'bold' }}>Title *</label>
                                        <InputText size="small" style={{ width: '100%' }} id="title" value={editTitle}
                                            onChange={(e) => {
                                                setEditTitle(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className='inputContainerDiv' style={{ width: '100%', }}>
                                        <label htmlFor="email" style={{ fontWeight: 'bold' }}>Pipeline *</label>
                                        <MultiSelect
                                            value={selectedPipelines}
                                            options={pipelinesList}
                                            itemTemplate={userTemplate}
                                            style={{ width: '100%' }}
                                            onChange={(event) => {
                                                setSelectedPipelines(event.value)
                                            }}
                                            placeholder='Select Pipelines'
                                            filter
                                        />
                                    </div>
                                    <FlexComponent justifyContent="center" gap="1rem" >
                                        <Button type='button' onClick={() => {
                                            handleEditSubmit(list.id)
                                        }} disabled={!editTitle.trim()} >Update</Button>
                                        <Button style={{ background: "white", color: " black" }} type='button' onClick={() => {
                                            setIsDesignationEdit(false)
                                        }} >Discard Changes</Button>
                                    </FlexComponent>
                                </FlexComponent>
                            )}

                            <FlexComponent alignItems="center" justifyContent="start" gap="1rem" >
                                <div htmlFor="subDesignationTitle" style={{ fontWeight: 'bold' }}>Sub-Designations</div>
                                <Button
                                    style={{ padding: ".5rem" }}
                                    onClick={() => {
                                        setShowAddSubDesignationInput(showAddSubDesignationInput === list.id ? null : list.id);
                                        setSubDesignationTitle('');
                                        setIsAddDesignation(false);
                                        setIsDesignationEdit(false);
                                        setEditSubDesignationId(null);
                                    }}
                                    icon="pi pi-plus"
                                />
                            </FlexComponent>

                            {showAddSubDesignationInput === list.id && (
                                <FlexComponent style={{ marginTop: ".5rem", border: "1px dashed grey", padding: "1rem", borderRadius: "10px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                                    <div className='inputContainerDiv' style={{ width: '100%' }}>
                                        <InputText size="small" style={{ width: '100%' }} id="subDesignationTitle" value={subDesignationTitle}
                                            onChange={(e) => {
                                                setSubDesignationTitle(e.target.value)
                                            }}
                                        />
                                    </div>
                                    <FlexComponent justifyContent="center" gap="1rem" >
                                        <Button type='button' onClick={() => handleAddSubDesignation(list.id)} label='Add Sub-Designation' disabled={!subDesignationTitle.trim()} />
                                        <Button style={{ background: "white", color: "black" }} type='button' label='Cancel' onClick={() => setShowAddSubDesignationInput(null)} />
                                    </FlexComponent>
                                </FlexComponent>
                            )}

                            {list.subdesignations && list.subdesignations.length > 0 && (
                                <div style={{ marginLeft: "2rem" }}>
                                    <ul>
                                        {list.subdesignations.map((sub, subIndex) => (
                                            <li key={subIndex} style={{ marginTop: ".5rem" }} >
                                                {editSubDesignationId === sub.id ? (
                                                    <FlexComponent style={{ marginTop: ".5rem", border: "1px dashed grey", padding: "1rem", borderRadius: "10px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                                                        <div className='inputContainerDiv' style={{ width: '100%' }}>
                                                            <InputText
                                                                size="small"
                                                                style={{ width: '100%' }}
                                                                id="editSubDesignationTitle"
                                                                value={editSubDesignationTitle}
                                                                onChange={(e) => setEditSubDesignationTitle(e.target.value)}
                                                            />
                                                        </div>
                                                        <FlexComponent justifyContent="center" gap="1rem">
                                                            <Button
                                                                type='button'
                                                                label='Update Sub-Designation'
                                                                onClick={() => handleUpdateSubDesignation(list.id, sub.id)}
                                                                disabled={!editSubDesignationTitle.trim()}
                                                            />
                                                            <Button
                                                                style={{ background: "white", color: "black" }}
                                                                type='button'
                                                                label='Cancel'
                                                                onClick={() => setEditSubDesignationId(null)}
                                                            />
                                                        </FlexComponent>
                                                    </FlexComponent>
                                                ) : (
                                                    <FlexComponent gap="1rem" alignItems="center">
                                                        <div>{sub.title}</div>
                                                        <div>
                                                            <Button
                                                                style={{ padding: ".3rem .4rem", marginRight:".5rem" }}
                                                                icon="pi pi-pencil"
                                                                onClick={() => handleEditSubDesignation(list.id, sub.id, sub.title)}
                                                            />
                                                            <Button
                                                                style={{ padding: ".3rem .4rem" }}
                                                                icon="pi pi-trash"
                                                                onClick={() => handleDeleteSubDesignation(list.id, sub.id)}
                                                            />
                                                        </div>
                                                    </FlexComponent>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <Divider />
                        </div>
                    ))}
                </div>}

            {loading && <FlexComponent justifyContent="center" >
                <ProgressSpinner />
            </FlexComponent>}

            <Button style={{ marginTop: ".5rem" }} onClick={handleClick} >Add Designation</Button>
            {isAddDesignation && <FlexComponent style={{ marginTop: "1rem", border: "1px solid grey", padding: "1rem", borderRadius: "15px" }} className='inputFlexContainer' flexDirection="column" gap='.5rem' alignItems='center'>
                <div className='inputContainerDiv' style={{ width: '100%' }}>
                    <label htmlFor="email" style={{ fontWeight: 'bold' }}>Title *</label>
                    <InputText size="small" style={{ width: '100%' }} id="title" value={title}
                        onChange={(e) => {
                            setTitle(e.target.value)
                        }}
                    />
                </div>
                <div className='inputContainerDiv' style={{ width: '100%' }}>
                    <label htmlFor="email" style={{ fontWeight: 'bold' }}>Pipeline *</label>
                    <MultiSelect
                        value={selectedPipelines}
                        options={pipelinesList}
                        itemTemplate={userTemplate}
                        style={{ width: '100%', color: 'black' }}
                        onChange={(event) => {
                            setSelectedPipelines(event.value)
                        }}
                        placeholder='Select Pipelines'
                        filter
                    />
                </div>
                <FlexComponent justifyContent="center" gap="1rem" >
                    <Button type='button' onClick={handleAddDesignation} disabled={!title.trim() || selectedPipelines.length === 0} >Save</Button>
                    <Button style={{ background: "white", color: "black" }} type='button' onClick={() => {
                        setIsAddDesignation(false)
                    }} >Cancel</Button>
                </FlexComponent>
            </FlexComponent>}
        </div>
    )
}

export default Designations